<p-tree [value]='geoAreaHierachy$ | async' layout='horizontal'>
  <ng-template let-node pTemplate="url">
    <a (click)='openURL(node.data)'><div pTooltip='{{node.data.time_zone}}' tooltipPosition='bottom'>{{node.label}}</div></a>
  </ng-template>
</p-tree>
